import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/icons/interface";
export function ProjectSettings() {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header><h3><Icon name="settings" />Project settings</h3><span>Read-only preview</span></header>;
    t1 = <legend>General</legend>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <label className="project-settings-row"><span>Project name</span><input value="Playground" readOnly={true} /></label>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <label className="project-settings-row"><span>Slug</span><input value="playground" readOnly={true} /></label>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <fieldset>{t1}{t2}{t3}<label className="project-settings-row"><span>Organization</span><input value="My organization" readOnly={true} /></label></fieldset>;
    t5 = <legend>Branches</legend>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="project-settings" aria-label="Project settings">{t0}{t4}<fieldset>{t5}<label className="project-settings-row"><span>Default branch</span><input value="main" readOnly={true} /></label></fieldset></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}